import React from "react";

export default function CustomDateCellWrapper({ children, value, events, currentView }) {
  const count = events.filter(
    (e) => new Date(e.start).toDateString() === value.toDateString()
  ).length;

  // Get props from child (which is the cell div)
  const child = React.Children.only(children);
  const childProps = child.props;

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        ...childProps.style, // preserve injected border/background styles!
      }}
      className={childProps.className} // preserve calendar styling
    >
      {child}
      {currentView === "month" && count > 1 && (
        <div
          style={{
            position: "absolute",
            top: 2,
            right: 4,
            fontSize: 13,
            backgroundColor: "#007bff",
            color: "#fff",
            borderRadius: "12px",
            padding: "2px 6px",
            fontWeight: 600,
          }}
        >
          {count}
        </div>
      )}
    </div>
  );
}
